import React from 'react'
import Theme from 'theme'
import { v4 as uuid } from 'uuid'
import packageInfo from '../../../package.json'
import { StyledFooter } from './Footer.styles'
import { termsAndConditionUrl } from 'config'

interface IFooterLink {
  label: string
  href?: string
  key: any
}

export const Footer: React.FC = () => {
  const links: IFooterLink[] = [
    {
      label: 'Terms and Conditions',
      href: termsAndConditionUrl,
      key: uuid(),
    },
  ]

  return (
    <StyledFooter
      backgroundColor={Theme.colors.ultraLightGrey}
      productName=""
      links={links}
      version={{
        label: packageInfo.version,
      }}
      textColor={Theme.colors.offGrey}
      topSpacing={0}
      margin={0}
    />
  )
}
